import axios, { AxiosInstance } from "axios";

export default class Backend {
  BASE_URL: string = `https://originrecord.herokuapp.com`;
  private static instance: Backend;
  private axiosInstance: AxiosInstance;

  private constructor(token?: string) {
    const headers: any = {};

    if (token) {
      headers.Authorization = `Token ${token}`;
    }

    this.axiosInstance = axios.create({
      baseURL: this.BASE_URL,
      headers: headers,
    });
  }

  static updateToken(value?: string) {
    Backend.instance = new Backend(value);
  }

  static getInstance() {
    return Backend.instance ?? new Backend();
  }

  axios() {
    return this.axiosInstance;
  }
}
